import { Box, Button, styled } from "@mui/material";

// Helper for consistent border color
const getBorderColor = (theme: any) => (theme.palette.mode === "light" ? "#e0e0e0" : "#4B5563");

export const DataTableContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  opacity: 1,

  tr: {
    backgroundColor: theme.palette.background.default,
    borderColor: getBorderColor(theme),
  },
  td: {
    backgroundColor: theme.palette.background.default,
    borderColor: getBorderColor(theme),
  },
  th: {
    borderColor: getBorderColor(theme),
  },
  "& .MuiPaper-root": {
    backgroundColor: theme.palette.background.default,
    borderColor: getBorderColor(theme),
  },
}));

export const BottomRow = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  border: `1px solid ${getBorderColor(theme)}`,
  height: "32px",
  borderRadius: "0 0 6px 6px",
}));

export const ClearButton = styled(Button)(({ theme }) => ({
  textDecoration: "underline",
  fontSize: "14px",
  textTransform: "none",
  "&:hover": {
    backgroundColor: theme.palette.background.default,
  },
}));
